import { Mapper } from "../../../../base/utils/mapper";

import { ContentAcademyModel }
from "../../../../domain/models/academy/content-academy.model";

import { ContentAcademyEntity }
from "../entities/content-academy.entity";

export class ContentAcademyImplementationRepositoryMapper
extends Mapper<
ContentAcademyEntity,
ContentAcademyModel
> {

    mapFrom(param:
    ContentAcademyEntity):
    ContentAcademyModel {

        return {
            ...param
        };
    }

    mapTo(param:
    ContentAcademyModel):
    ContentAcademyEntity {

        return {
            ...param
        };
    }
}